import {useMutation} from '@apollo/react-hooks'
import gql from 'graphql-tag'
import {useQuery} from 'react-apollo'

import {ACCOUNTS_QUERY, WITHDRAWAL_FIELDS_FRAGMENT} from '../../../../graphql/queries'
import {CreateWithdrawalItem} from './types'

const CREATE_WITHDRAWAL_REQUESTS_MUTATION = gql`
  ${WITHDRAWAL_FIELDS_FRAGMENT}
  mutation ($items: [CreateWithdrawalRequestInputType!]!) {
    createWithdrawalRequests(items: $items) {
      ...WithdrawalFields
    }
  }
`

function useCreateWithdrawalsRequest() {
  const [mutation, {loading}] = useMutation(CREATE_WITHDRAWAL_REQUESTS_MUTATION, {
    refetchQueries: [{query: ACCOUNTS_QUERY}]
  })
  const createWithdrawalRequests = (items: CreateWithdrawalItem[]) => mutation({variables: {items}})

  return {createWithdrawalRequests, loading}
}

const FETCH_CLIENT_DEPOSIT_METHOD_ISSUE_VERIFICATION = gql`
  query {
    viewer {
      ... on Client {
        id
        depositMethodIssueVerifications {
          id
          accountId
          clientId
          paymentMethodOptionId
          fileUrl
          comment
          internalRemark
          processStatus
          meta
          createdAt
          updatedAt
          __typename
        }
      }
    }
  }
`

function useFetchClientDepositMethodIssueVerifications(clientId) {
  const {loading, data} = useQuery(FETCH_CLIENT_DEPOSIT_METHOD_ISSUE_VERIFICATION, {
    variables: {id: clientId}
  })

  const depositMethodIssueVerifications = data?.viewer?.depositMethodIssueVerifications || []

  return {
    depositMethodIssueVerifications,
    loading
  }
}

export {
  useCreateWithdrawalsRequest,
  useFetchClientDepositMethodIssueVerifications,
  FETCH_CLIENT_DEPOSIT_METHOD_ISSUE_VERIFICATION
}
